import { axios, baseURL } from './types';
import {
  GET_REMINDERS_REQUEST,
  GET_REMINDERS_SUCCESS,
  GET_REMINDERS_FAIL,
} from './types';


const getLoginDetails = () => {
  const loginData = JSON.parse(localStorage.getItem('loginData') || '{}');
  return {
    token: loginData.token || '',
    hospitalID: loginData.hospitalID || '' 
  };
};

export const getAllPatientReminders = () => (dispatch) => {
  dispatch({ type: GET_REMINDERS_REQUEST });


  const { token, hospitalID } = getLoginDetails();

  const config = {
    method: 'POST',
    url: `${baseURL}/api/appointementPatientRemindedData/getAllPatientsDetails`,
    headers: {
      'Content-Type': 'application/json',
      'Authorization': `Bearer ${token}` 
    },
    data: { 
      hospitalID: hospitalID 
    }
  };

  return axios(config)
    .then((response) => {
      if (response.data.success === 1) {
        dispatch({
          type: GET_REMINDERS_SUCCESS,
          payload: response.data.data, 
        });
      }
    })
    .catch((error) => {
      dispatch({
        type: GET_REMINDERS_FAIL,
        payload: error.response?.data?.message || error.message || "Server Error",
      });
    });
};